export { default } from './CapacityChip';
